import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import { Menu, Typography } from '@mui/material';
import { formatToKebabCase } from '../../utils/helpers';

type PropsType = {
  text: string;
  icon: JSX.Element;
  select: string;
  type?: string;
  onClick?: any;
};

const ViewOption = ({ text, icon, select, onClick, type = 'page' }: PropsType) => {
  const router = useRouter();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {type === 'menu' ? (
        <p
          className={open ? 'chooseview-active' : 'chooseview'}
          style={{ cursor: 'pointer' }}
          aria-controls={open ? text : ''}
          data-test-id={`lhn-${formatToKebabCase(text)}`}
          onClick={handleClick}
          anchororigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <>
            {icon}
            {text}
          </>
        </p>
      ) : (
        <Link href={select}>
          <p
            className={router.pathname == select ? 'chooseview-active' : 'chooseview'}
            style={{ cursor: 'pointer' }}
            onClick={onClick ? onClick : () => {}}
            data-test-id={`lhn-${formatToKebabCase(text)}`}
          >
            <>
              {icon}
              {text}
            </>
          </p>
        </Link>
      )}
      <Menu
        id={'Help'}
        data-test-id="lhn-help"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div
          style={{
            width: '12rem',
            display: 'flex',
            flexDirection: 'column',
            padding: '1rem',
            gap: '.7rem',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <Typography data-test-id="help-menu-title" variant="body3">
              Help & Support
            </Typography>
          </div>
          <div>
            <Typography variant="tocSub">
              <a
                href={'mailto:' + 'customersupport@trinnex.io?subject=leadCAST Support'}
                style={{ color: 'inherit' }}
              >
                {' '}
                {'Email Support'}{' '}
              </a>
            </Typography>
          </div>
          <div>
            <Typography variant="tocSub">
              <a
                href={'https://trinnex.zendesk.com/hc/en-us'}
                target={'_blank'}
                style={{ color: 'inherit' }}
              >
                {' '}
                {'Guides and Training'}{' '}
              </a>
            </Typography>
          </div>
        </div>
      </Menu>
    </>
  );
};

export default ViewOption;
